export default "__VITE_ASSET__BvQfl$du__"